import { CerGridEditSettings, CerGridSelectionInitial, CerGridSelectionMode, CerGridToolbarType, CerToolbarTitle } from "./cer-grid.component";

export class GridDesign {
  public id: string;
  public allowPaging: boolean;
  public fixedHugePage: boolean;
  public pagingVirtual: boolean;
  public useEditTemplate: boolean;
  public groupingLazyLoading: boolean;
  public useMaxHeight: boolean;
  public autoFocus: boolean;
  public card: boolean;
  public toolbarType: CerGridToolbarType;
  public toolbarTitle: CerToolbarTitle;
  public columnFilterVisible: boolean = true;
  public dataParent: boolean = false;
  public dataChild: boolean = false;
  public dataChildrenExists: boolean;
  public selectionMode: CerGridSelectionMode;
  public selectionInitial: CerGridSelectionInitial;
  public editSettings: CerGridEditSettings;
}
